import { ActionBase } from '../../../core/store/action/ActionBase';
import { SupportTicketInformationModel } from '../../models/SupportTicketInformationModel';

export const GET_SUPPORT_TICKET_INFORMATION_SUCCESS_ACTION = '[Configuration] Get Support Ticket Information Success Action';

export class GetSupportTicketInformationSuccessAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GET_SUPPORT_TICKET_INFORMATION_SUCCESS_ACTION;

  constructor(public payload: { supportTicketInformation: SupportTicketInformationModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/GetSupportTicketInformationSuccessAction.ts